<template>
    <tr>
        <td>
            <i :class="isSelected()" @click="setFilter()"></i>
        </td>
        <td>
            <div class="font-input">{{ item.type }}</div>
        </td>
    </tr>
</template>

<script>
  import modals from '../../data/modals'

  export default {
    props: ['item'],
    data () {
      return {
        selected: modals.filter
      }
    },
    methods: {
      isSelected () {
        if (this.selected.includes(this.item.id)) {
          return 'fas fa-check-circle'
        } else {
          return 'far fa-circle'
        }
      },
      setFilter () {
        if (modals.filter.includes(this.item.id)) {
          modals.filter.splice(modals.filter.indexOf(this.item.id), 1)
        } else {
          modals.filter.push(this.item.id)
        }
        this.selected = modals.filter
      }

    }

  }
</script>

<style lang="scss" scoped>
    @import '../../styles/app';

    td {
        margin: 0;
        padding: 15px 0 !important;
        text-align: left !important;
        line-height: 24px;
        i {
            font-size: 24px;
            vertical-align: middle;
        }
        .fa-check-circle {
            color: $color-secondary;
        }
        .fa-circle {
            color: $color-btn-border;
        }
        &:nth-of-type(1) {
            border: none;
        }

        &:nth-of-type(2) {
            width: 90%;
            border-top: none;
            .font-input {
                font-weight: normal;
            }
        }
    }
</style>
